(() => {
  if (window.wallifyDrawersInitialized) return;
  window.wallifyDrawersInitialized = true;
  let activeDrawer = null;
  let returnFocus = null;
  let previousOverflow = '';

  const focusable = (drawer) => Array.from(drawer.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.closest('[inert]') && element.getClientRects().length);

  const triggersFor = (drawer) => Array.from(document.querySelectorAll('[data-drawer-open]'))
    .filter((trigger) => trigger.dataset.drawerOpen === drawer.dataset.drawer);

  function closeDrawer(restoreFocus = true) {
    if (!activeDrawer) return;
    const drawer = activeDrawer;
    activeDrawer = null;
    drawer.classList.remove('active');
    drawer.removeAttribute('open');
    drawer.inert = true;
    triggersFor(drawer).forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = previousOverflow;
    if (restoreFocus && returnFocus?.isConnected) returnFocus.focus();
    returnFocus = null;
  }

  function openDrawer(drawer, trigger) {
    if (activeDrawer === drawer) return;
    if (activeDrawer) closeDrawer(false);
    previousOverflow = document.body.style.overflow;
    returnFocus = trigger;
    activeDrawer = drawer;
    drawer.inert = false;
    drawer.classList.add('active');
    drawer.setAttribute('open', '');
    triggersFor(drawer).forEach((button) => button.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
    const content = drawer.querySelector('.drawer-content');
    if (content) content.setAttribute('tabindex', '-1');
    (drawer.querySelector('[data-drawer-close]') || focusable(drawer)[0] || content)?.focus();
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-drawer]').forEach((drawer) => {
      if (drawer === activeDrawer) return;
      drawer.inert = !drawer.hasAttribute('open');
    });
    root.querySelectorAll('.drawer_menu_item').forEach((item) => {
      const panel = item.querySelector(':scope > .drawer_submenu');
      const row = item.querySelector(':scope > .drawer_menu_row');
      if (!panel || !row) return;
      if (item.hasAttribute('data-default-collapsed')) return;
      panel.classList.add('active');
      row.classList.add('active');
      row.setAttribute('aria-expanded', 'true');
      item.classList.add('active');
    });
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-drawer-open]');
    if (openButton) {
      const drawer = Array.from(document.querySelectorAll('[data-drawer]'))
        .find((candidate) => candidate.dataset.drawer === openButton.dataset.drawerOpen);
      if (drawer) {
        event.preventDefault();
        openDrawer(drawer, openButton);
      }
      return;
    }
    const closeTarget = event.target.closest('[data-drawer-close], [data-drawer-overlay]');
    if (closeTarget && closeTarget.closest('[data-drawer]') === activeDrawer) {
      closeDrawer();
      return;
    }
    const row = event.target.closest('.drawer_menu_row');
    if (!row) return;
    const item = row.closest('.drawer_menu_item');
    const panel = item?.querySelector(':scope > .drawer_submenu');
    if (!panel) return;
    const expanded = row.getAttribute('aria-expanded') !== 'true';
    row.setAttribute('aria-expanded', String(expanded));
    row.classList.toggle('active', expanded);
    item.classList.toggle('active', expanded);
    panel.classList.toggle('active', expanded);
  });

  document.addEventListener('keydown', (event) => {
    if (!activeDrawer || event.defaultPrevented) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusable(activeDrawer);
    const first = items[0];
    const last = items[items.length - 1];
    if (!first) {
      event.preventDefault();
      activeDrawer.querySelector('.drawer-content')?.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('focusin', (event) => {
    if (!activeDrawer || activeDrawer.contains(event.target)) return;
    (focusable(activeDrawer)[0] || activeDrawer.querySelector('.drawer-content'))?.focus();
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (activeDrawer && event.target.contains(activeDrawer)) closeDrawer(false);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
})();


